/*
    Developer Name :  RAJA
    Developed Date :  03-12-2021
    Page Name      :  Item Mfr Mst Service
    Created        :  03-12-2021
    Last Edited By : 
    Edited Date    : 
    Last Edited    : 
*/
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ItemMfrApi} from '../../api/master/item-mfr-mst.api';
import { switchMap, map } from 'rxjs/operators';
import { ItemMfrData,ItemMfr  } from '../../interface/master/item-mfr-mst';

@Injectable()
export class ItemMfrService extends ItemMfrData {

  constructor(private api: ItemMfrApi) {
    super();
  }


  list(url: string): Observable<ItemMfr[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<ItemMfr>{
      return this.api.getById(url);
  }

  create(url: string, data:ItemMfr): Observable<ItemMfr> {
    return this.api.add(url,data);
  }

  update(url: string, data:ItemMfr): Observable<ItemMfr> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  postData(url: string, data: any[]): Observable<any> {
    return this.api.addData(url, data);
  }

}
